<template>
  <div>
    <section class="p-box">
      <header class="p-box__header">
        <div class="p-filtersA">
          <div class="p-filtersA__left" />
          <div class="p-filtersA__right">
            <div class="c-searchField">
              <input
                v-model="searchQuery"
                type="text"
                class="searchForm"
                :placeholder="$t('labels.locationOrStoreCodeSearch')"
                @keydown.enter="search"
              >
              <Icon name="iconSearch" />
            </div>
          </div>
        </div>
      </header>
      <div v-if="!loading" class="p-box__body">
        <div v-if="gmb_location_sync_logs && gmb_location_sync_logs.length != 0" class="p-table">
          <div class="c-info">
            <Icon class="description" name="iconProtection" />
            <p>{{ $t('pages.CompaniesGMBLocationSyncLogs.description') }}</p>
          </div>
          <div class="p-table__content">
            <table>
              <thead>
                <tr>
                  <th><span>{{ $t('pages.CompaniesGMBLocationSyncLogs.tableAttributes.createdAt') }}</span></th>
                  <th><span>{{ $t('pages.CompaniesGMBLocationSyncLogs.tableAttributes.storeName') }}</span></th>
                  <th><span>{{ $t('pages.CompaniesGMBLocationSyncLogs.tableAttributes.message') }}</span></th>
                  <th><span>{{ $t('pages.CompaniesGMBLocationSyncLogs.tableAttributes.gmbLocationAttribute') }}</span></th>
                  <th><span>{{ $t('pages.CompaniesGMBLocationSyncLogs.tableAttributes.localStoreAttribute') }}</span></th>
                </tr>
                <tr class="p-table__content__space"><td colspan="5" /></tr>
              </thead>
              <tbody>
                <tr v-for="log in gmb_location_sync_logs" :key="log.id">
                  <td class="u-fwB p-table__content__created-at">{{ basicDateTimeFormat(log.attributes.created_at) }}</td>
                  <td class="u-fwB p-table__content__store-name">{{ log.attributes.store_name }}</td>
                  <td class="u-fwB p-table__content__message">{{ message(log.attributes.kind) }}</td>
                  <td class="p-table__content__block-content" :class="{'u-fwB': log.attributes.kind !== 'description'}">
                    <div class="with-icon-content">
                      <span>
                        <Icon name="iconCrossRed" />
                      </span>
                      <div v-if="log.attributes.kind === 'description'" class="with-icon-content__content">
                        <p>
                          <span v-for="(diffText, diffTextIndex) in getDiffTextList(log.attributes.gmb_locations_attribute, log.attributes.stores_attribute)" :key="`block_${diffTextIndex}`">
                            <span v-if="diffText[0] === 0">{{ diffText[1] }}</span>
                            <span v-if="diffText[0] === -1" class="diff-text-highlight">{{ diffText[1] }}</span>
                          </span>
                        </p>
                      </div>
                      <div v-else class="with-icon-content__content">
                        <p v-for="attr in splitAttribute(log.attributes.gmb_locations_attribute)" :key="attr">{{ attr }}</p>
                      </div>
                    </div>
                  </td>
                  <td class="p-table__content__protected-content" :class="{'u-fwB': log.attributes.kind !== 'description'}">
                    <div class="with-icon-content">
                      <span>
                        <Icon name="iconProtection" />
                      </span>
                      <div v-if="log.attributes.kind === 'description'" class="with-icon-content__content">
                        <p>
                          <span v-for="(diffText, diffTextIndex) in getDiffTextList(log.attributes.gmb_locations_attribute, log.attributes.stores_attribute)" :key="`protected_${diffTextIndex}`">
                            <span v-if="diffText[0] === 0">{{ diffText[1] }}</span>
                            <span v-if="diffText[0] === 1" class="diff-text-highlight">{{ diffText[1] }}</span>
                          </span>
                        </p>
                      </div>
                      <div v-else class="with-icon-content__content">
                        <p v-for="attr in splitAttribute(log.attributes.stores_attribute)" :key="attr">{{ attr }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="p-controller">
            <div class="p-controller__count">
              <p class="p-controller__count__name">{{ $t('labels.perPageCount') }}</p>
              <div class="p-controller__count__select">
                <select v-model="per">
                  <option v-for="item in 5" :key="item" :value="item * 50">{{ item * 50 }}</option>
                </select>
              </div>
              <p class="p-controller__count__current">{{ startDataNumber }}-{{ endDataNumber }}</p>
            </div>
            <div class="p-controller__navi">
              <button
                type="button"
                :disabled="currentPage === 1"
                class="p-controller__navi__prev"
                @click="goPrevPage"
              >
                <Icon name="arrowLeft" />
              </button>
              <button
                type="button"
                :disabled="currentPage >= meta.total_pages"
                class="p-controller__navi__next"
                @click="goNextPage"
              >
                <Icon name="arrowRight" />
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          {{ $t('messages.noData') }}
        </div>
      </div>
      <Loading v-show="loading" />
    </section>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import moment from 'moment'
import Loading from '../components/Loading.vue'
import Icon from '../components/Icon.vue'
import { gmbLocationSyncLogConst } from '../modules/gmbLocationSyncLogConst'
import { i18n } from '../plugins/i18n'
import DiffMatchPatch from 'diff-match-patch'

export default {
  name: 'CompaniesGMBLocationSyncLogs',
  components: {
    Loading,
    Icon,
  },
  data () {
    return {
      searchQuery: this.$route.query['q[name_cont]'] || '',
      currentPage: Number(this.$route.query['page']) || 1,
      per: Number(this.$route.query['per']) || 50,
    }
  },
  computed: {
    ...mapState({
      gmb_location_sync_logs: state => state.companiesGmbLocationSyncLogs.data,
      meta: state => state.companiesGmbLocationSyncLogs.meta,
      loading: state => state.companiesGmbLocationSyncLogs.loading,
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    startDataNumber() {
      return (this.currentPage - 1) * this.per + 1
    },
    endDataNumber() {
      return this.startDataNumber + this.gmb_location_sync_logs.length - 1
    }
  },
  watch: {
    per() {
      this.resetPage()
      const query = { ...this.$route.query, 'per': this.per }
      this.handleQuerySubmit(query)
    }
  },
  created() {
    this.readGmbLocationSyncLogs(this.currentCompanyUuid)
    this.clearUnreadGmbLocationSyncLogsCount({ companyUuid: this.currentCompanyUuid })
  },
  methods: {
    ...mapActions({
      readGmbLocationSyncLogs: 'companiesGmbLocationSyncLogs/readGmbLocationSyncLogs',
      clearUnreadGmbLocationSyncLogsCount: 'companiesUserActivity/clearUnreadGmbLocationSyncLogsCount',
    }),
    basicDateTimeFormat: function( date ) {
      return date ? moment( date ).format(this.$t('format.datetime.default')) : ''
    },
    goPrevPage() {
      --this.currentPage
      this.changePage()
    },
    goNextPage() {
      ++this.currentPage
      this.changePage()
    },
    changePage() {
      const query = { ...this.$route.query, 'page': this.currentPage }
      window.scrollTo({ top: 0 })
      this.handleQuerySubmit(query)
    },
    search(event) {
      if (event.keyCode !== 13) return
      if (this.searchQuery === (this.$route.query['q[name_cont]'] || '')) return

      this.resetPage()
      const query = { ...this.$route.query, 'q[name_cont]': this.searchQuery || undefined, 'q[option_code_cont]': this.searchQuery || undefined, 'q[m]': 'or' }
      this.handleQuerySubmit(query)
    },
    resetPage() {
      this.currentPage = 1
      this.$route.query.page = undefined
    },
    async handleQuerySubmit(query) {
      await this.$router.push({ query: query })
      this.readGmbLocationSyncLogs(this.currentCompanyUuid)
    },
    splitAttribute(attribute) {
      return attribute.split(',')
    },
    getDiffTextList(beforeText, afterText) {
      let dmp = new DiffMatchPatch()
      let diffTextList = dmp.diff_main(beforeText, afterText)
      return diffTextList
    },
    message(kind) {
      switch (kind) {
      case gmbLocationSyncLogConst.locationName:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.locationName')
      case gmbLocationSyncLogConst.description:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.description')
      case gmbLocationSyncLogConst.websiteUrl:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.websiteUrl')
      case gmbLocationSyncLogConst.addressLines:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.addressLines')
      case gmbLocationSyncLogConst.administrativeArea:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.administrativeArea')
      case gmbLocationSyncLogConst.postalCode:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.postalCode')
      case gmbLocationSyncLogConst.primaryPhone:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.primaryPhone')
      case gmbLocationSyncLogConst.additionalPhones:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.additionalPhones')
      case gmbLocationSyncLogConst.payDebitCard:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.payDebitCard')
      case gmbLocationSyncLogConst.requiresCashOnly:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.requiresCashOnly')
      case gmbLocationSyncLogConst.payCheck:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.payCheck')
      case gmbLocationSyncLogConst.payMobileNfc:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.payMobileNfc')
      case gmbLocationSyncLogConst.payCreditCardTypesAccepted:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.payCreditCardTypesAccepted')
      case gmbLocationSyncLogConst.regularHours:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.regularHours')
      case gmbLocationSyncLogConst.primaryCategory:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.primaryCategory')
      case gmbLocationSyncLogConst.additionalCategories:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.additionalCategories')
      case gmbLocationSyncLogConst.attributes:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.attributes')
      case gmbLocationSyncLogConst.openInfo:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.openInfo')
      case gmbLocationSyncLogConst.storeCode:
        return i18n.t('pages.CompaniesGMBLocationSyncLogs.messages.storeCode')
      default:
        return ''
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.p-controller {
  margin-top: 10px;
}
.c-searchField{
  width: 220px;
}
td.u-fwB {
  &:empty {
    display: inline;
  }
}
.p-table {
  margin-top: 0px;
  &__content {
    word-break: break-all;
    &__created-at {
      width: 15%;
      background-color: #ECEDF0;
    }
    &__store-name {
      width: 15%;
      background-color: #ECEDF0;
    }
    &__message {
      width: 20%;
    }
    &__protected-content {
      width: 25%;
    }
    &__block-content {
      width: 25%;
    }
  }
}
.description {
  margin-right: 3px;
}
.with-icon-content {
  display: inline-flex;
  align-items: center;
  width: 100%;
  &__content {
    width: 95%;
    padding-left: 20px;
  }
}
.diff-text-highlight {
  font-weight: bold;
  background: linear-gradient(transparent 0%, #f9cdd7 0%);
}
</style>
